// src/app/interceptors/http-error.interceptor.ts
import {
  HttpInterceptorFn,
  HttpErrorResponse,
  HttpContextToken,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { catchError, throwError } from "rxjs";

export const SILENT_401 = new HttpContextToken<boolean>(() => false);

const ERROR_MESSAGES: Record<string, string> = {
  SCHEDULE_CONFLICT: "The instructor is already book during this time.",
  VALIDATION_ERROR: "Invalid data.",
  PRECONDITION_FAILED: "Non satisfying conditions.",
  INTERNAL: "Internal error.",
};

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const snack = inject(MatSnackBar);
  const router = inject(Router);

  // Ex: ne pas toaster les 404/401 des fichiers statiques
  const isAsset = req.url.includes("/assets/");

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      // 0 = réseau coupé / CORS / serveur down
      if (err.status === 0) {
        const msg = "Cannot reach the server. Verify your connection.";
        if (!isAsset) snack.open(msg, "OK", { duration: 4000 });
        return throwError(() => ({
          ...err,
          code: "NETWORK",
          userMessage: msg,
        }));
      }

      // 401 → silencieux sur /login ou si marqué SILENT_401
      const onLogin = router.url.startsWith("/login");
      const silent401 = req.context.get(SILENT_401);
      if (err.status === 401 && (onLogin || silent401)) {
        return throwError(() => err);
      }

      // Construire le message “propre”
      const payload: any = err.error ?? {};
      const code: string | undefined = payload?.error;
      const msg =
        payload?.message ||
        (code && ERROR_MESSAGES[code]) ||
        err.statusText ||
        "An error has occured.";

      // Toast (sauf assets)
      if (!isAsset) snack.open(msg, "OK", { duration: 4000 });

      // Propager une erreur normalisée
      return throwError(() => ({
        ...err,
        code,
        userMessage: msg,
        details: payload?.details,
      }));
    })
  );
};
